/* eslint-disable @typescript-eslint/no-empty-object-type */
import { useDispatch } from 'react-redux';
import {
  AnyAction,
  applyMiddleware,
  compose,
  createStore,
  Middleware,
} from 'redux';
import logger from 'redux-logger';
import thunk, { ThunkMiddleware } from 'redux-thunk';

import rootReducer from './rootReducer';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const isProduction = import.meta.env.NODE_ENV === 'production';
const isDevelopment = import.meta.env.NODE_ENV === 'development';

const composeEnhancers =
  (!isProduction &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const middlewares: Array<
  Middleware<{}, any> | ThunkMiddleware<any, AnyAction>
> = [thunk];

if (isDevelopment && import.meta.env.VITE_APP_ENABLE_REDUX_LOGGER === 'true') {
  middlewares.push(logger as Middleware<{}, any>);
}

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares))
);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
